import type { SVGProps } from 'react'
const SvgEntitiesNavIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="17"
    height="17"
    viewBox="0 0 17 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M12.1007 10.7906H11.6123L10.9301 10.1085C11.6796 9.10642 12.1007 7.84326 12.1007 6.5801C12.1007 3.32115 9.46488 0.685364 6.20594 0.685364C4.94278 0.685364 3.67962 1.10642 2.66067 1.86431C0.0585674 3.818 -0.471959 7.51484 1.48173 10.1169C3.43541 12.719 7.13225 13.2496 9.73436 11.2959L10.4165 11.978V12.4748L14.627 16.6854L16.3112 15.0012L12.1007 10.7906ZM6.20594 10.7906C3.88173 10.7906 1.99541 8.90431 1.99541 6.5801C1.99541 4.25589 3.88173 2.36957 6.20594 2.36957C8.53015 2.36957 10.4165 4.25589 10.4165 6.5801C10.4165 8.90431 8.53015 10.7906 6.20594 10.7906Z"
      fill="#5E5E5E"
    />
  </svg>
)
export default SvgEntitiesNavIcon
